import React, { useEffect, useState } from "react";
import Link from "next/link";
import BlogOffers from "@components/Features/blog/blog-offers/blog-offers";
import BlogSocial from "@components/Features/blog/blog-social/blog-social";
import { BlogWidget } from "@components/Features/blog/blog-widget/blog-widget";
import Container from "@components/Features/blog/container/container";
import { useGetOffersQuery } from "@app/store/offersApi";
import Car from "@shared/lib/interfaces/car.interface";
import { RouterConfig } from "@shared/lib/routerConfig";
import { Breadcrumbs } from "@shared/ui/Breadcrumbs";
import { formatDate } from "../../../utils/utils";
import CancelIcon from "../../Svg/CancelIcon";
import { BlogPostScreenProps } from "./types";
import classes from "./BlogPostScreen.module.scss";

const BlogPostScreen: React.FC<BlogPostScreenProps> = ({ post, searchTerms }) => {
    const postLink = process.env.NEXT_PUBLIC_DOMAIN + "/blog/" + (post?.slug ?? "").toString();

    useEffect(() => {
        if (post && post?.id) {
            fetch(`https://cms.likvi.com/wp-json/post-views-counter/view-post/${post.id}`, {
                method: "POST"
            });
        }
    }, [post]);

    useEffect(() => {
        let newFilters: any[] = [];

        if (searchTerms) {
            if (searchTerms.mark) {
                newFilters.push({
                    match_phrase: {
                        mark: searchTerms.mark
                    }
                });
            }
            if (searchTerms.model) {
                newFilters.push({
                    match_phrase: {
                        model: searchTerms.model
                    }
                });
            }
            if (searchTerms.generation) {
                newFilters.push({
                    bool: {
                        should: [
                            {
                                term: {
                                    generation_number: searchTerms.generation
                                }
                            }
                        ]
                    }
                });
            }
        }
    }, [searchTerms]);

    const { data } = useGetOffersQuery({
        page: 1,
        brandUuid: searchTerms.mark,
        modelUuid: searchTerms.model,
        generationUuid: searchTerms.generation,
        sort: "created_at@desc"
    });

    const [dataMemory, setDataMemory] = useState<Car[]>([]);

    useEffect(() => {
        if (data && data.offers) {
            setDataMemory(data.offers.slice(0, 4));
        }
    }, [data]);

    return (
        <div className={classes.BlogPostScreen}>
            <Container>
                <Breadcrumbs
                    className={classes.BreadCrumbs}
                    prevItems={[{ href: RouterConfig.BLOG, text: "Блог" }]}
                    title={post?.title?.rendered || ""}
                />
                {!post && (
                    <div className={classes.NotFound}>
                        <h1>Ой! Такой страницы на нашем сайте нет :(</h1>
                        <p>
                            Наверное, вы ошиблись при наборе адреса или перешли по неверной ссылке.
                        </p>
                    </div>
                )}
                {post && (
                    <div className={classes.BlogPost}>
                        <div className={classes.Content}>
                            <div className={classes.Title}>
                                <h1>{post?.title?.rendered}</h1>
                                <div className={classes.Close}>
                                    <Link href="/blog">
                                        <CancelIcon color="#000" />
                                    </Link>
                                </div>
                            </div>
                            <div className={classes.Date}>
                                {post?.date && formatDate(post?.date?.toString())}
                            </div>
                            <div className={classes.Image}>
                                <img
                                    src={
                                        post?.x_featured_media_large ??
                                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO8f/d+PQAIWgMcDMOFRwAAAABJRU5ErkJggg=="
                                    }
                                    alt={post?.title?.rendered}
                                />
                            </div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: post?.content?.rendered
                                }}
                                className={classes.ContentFromWP}
                            ></div>
                        </div>
                        <aside className={classes.Nav}>
                            <div className={classes.Close}>
                                <Link href="/blog">
                                    <CancelIcon color="#000" />
                                </Link>
                            </div>

                            {post?.link && (
                                <BlogSocial
                                    postLink={postLink}
                                    title={post?.title?.rendered ?? ""}
                                />
                            )}
                        </aside>
                    </div>
                )}
                {dataMemory.length > 0 && post && <BlogOffers offers={dataMemory} />}
            </Container>
            <BlogWidget title={"Читайте также"} id={post?.id ?? 0} />
        </div>
    );
};

export default BlogPostScreen;